export default function About() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-24 bg-gradient-to-br from-[#1A2B4A] to-[#2C4A7C] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="w-full h-[500px] rounded-[32px] overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20premium%20white%20wall%20mounted%20air%20conditioner%20unit%20installed%20in%20elegant%20bright%20living%20room%20interior%20clean%20minimalist%20design%20high%20end%20residential%20cooling%20system%20sleek%20contemporary%20style%20neutral%20background&width=800&height=600&seq=about-ac-unit-002&orientation=landscape"
                alt="Climatizzatore professionale Ravenna"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Badge */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#FF6B35] rounded-full flex items-center justify-center shadow-xl">
              <div className="text-center">
                <div className="text-white font-bold text-3xl">30+</div>
                <div className="text-white text-xs font-semibold">Anni<br />Esperienza</div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-block bg-[#00A3E0]/20 border border-[#00A3E0]/40 text-white px-5 py-2 rounded-full text-sm font-semibold mb-6">
              CHI SIAMO
            </div>

            <h2 className="text-white font-bold text-5xl mb-6 leading-tight">
              Professionisti del Clima a Ravenna
            </h2>

            <p className="text-white/85 text-lg leading-relaxed mb-8">
              Tecnici specializzati nell'installazione e manutenzione di climatizzatori a Ravenna e provincia. Servizio rapido, affidabile e prezzi competitivi. Disponibili 24 ore su 24 per emergenze e interventi urgenti.
            </p>

            {/* Features List */}
            <div className="space-y-4 mb-10">
              <div className="flex items-center gap-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#00A3E0]/20">
                  <i className="ri-check-line text-[#00A3E0] text-xl"></i>
                </div>
                <span className="text-white text-base font-medium">Tecnici certificati e qualificati</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#00A3E0]/20">
                  <i className="ri-check-line text-[#00A3E0] text-xl"></i>
                </div>
                <span className="text-white text-base font-medium">Interventi rapidi entro 2 ore</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#00A3E0]/20">
                  <i className="ri-check-line text-[#00A3E0] text-xl"></i>
                </div>
                <span className="text-white text-base font-medium">Garanzia su tutti i lavori</span>
              </div>
            </div>

            {/* CTA Button */}
            <button
              onClick={scrollToContact}
              className="inline-flex items-center gap-3 bg-white text-[#1A2B4A] px-8 py-4 rounded-full font-bold text-base hover:bg-[#E6F4FF] transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
            >
              Contattaci
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}